import React from 'react';

export interface BidItem {
  _id: string;
  displayName: string;
  twitchUsername: string;
  amount: number;
  isManual?: boolean;
  createdAt?: string;
}

interface BidHistoryModalProps {
  title: string;
  bids: BidItem[];
  onClose: () => void;
}

const BidHistoryModal: React.FC<BidHistoryModalProps> = ({ title, bids, onClose }) => (
  <div
    className="fixed inset-0 z-[1000] flex items-center justify-center p-4 bg-black/75"
    onClick={onClose}
    role="presentation"
  >
    <div
      className="w-full max-w-md max-h-[80vh] flex flex-col rounded-2xl border border-white/10 bg-gradient-to-b from-[#1a1333] to-[#0d0a1a] p-5 shadow-2xl"
      onClick={(e) => e.stopPropagation()}
      role="dialog"
      aria-modal
    >
      <div className="flex justify-between items-center gap-2 mb-4">
        <h3 className="text-lg font-semibold text-white/90 m-0">{title}</h3>
        <button
          type="button"
          onClick={onClose}
          className="px-3 py-1.5 rounded-xl text-sm border border-white/15 text-slate-300 hover:text-white"
        >
          Cerrar
        </button>
      </div>
      <div className="overflow-y-auto space-y-2 flex-1">
        {bids.map((b, i) => (
          <div
            key={b._id}
            className={[
              'flex justify-between gap-3 px-3 py-2.5 rounded-xl text-sm',
              i === 0 ? 'border border-rose-400/40 bg-rose-400/10' : 'border border-white/5',
            ].join(' ')}
          >
            <span>{b.displayName}{b.isManual ? ' (manual)' : ''}</span>
            <strong>${b.amount}</strong>
          </div>
        ))}
        {!bids.length && <p className="text-slate-500 text-sm">Sin pujas todavía.</p>}
      </div>
    </div>
  </div>
);

export default BidHistoryModal;
